// Prevent errors on Meta browsers - Sentry IMPACT-FRONTEND-3
window._AutofillCallbackHandler = window._AutofillCallbackHandler || function () {
}

const loadScript = (url, async = true) => {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = async;
    script.src = url;
    document.body.appendChild(script);
}

const loadWistiaMedia = (videoId) => loadScript(`https://fast.wistia.com/embed/medias/${videoId}.jsonp`)
const loadWistiaLibrary = () => loadScript('https://fast.wistia.com/assets/external/E-v1.js')

// Find the Y top offset of the element
// relative to the page top
const findYPos = (element) => {
    let curtop = 0

    if (!element.offsetParent) {
        return curtop
    }

    do {
        curtop += element.offsetTop
        element = element.offsetParent
    }
    while (element)

    return curtop
}

const storeInSessionUTMs = () => {
    if (!window.location.href.includes('utm_source')) {
        return
    }

    const queryParams = new URLSearchParams(window.location.search)
    sessionStorage.setItem('utm_source', queryParams.get('utm_source') || 'undefined')
    sessionStorage.setItem('utm_medium', queryParams.get('utm_medium') || 'undefined')
    sessionStorage.setItem('utm_campaign', queryParams.get('utm_campaign') || 'undefined')
    sessionStorage.setItem('utm_term', queryParams.get('utm_term') || 'undefined')
    sessionStorage.setItem('utm_content', queryParams.get('utm_content') || 'undefined')
}
const getUTMParameters = () => {
    if (!sessionStorage.getItem('utm_source')) {
        return null
    }

    const queryParams = new URLSearchParams()
    queryParams.set('utm_source', sessionStorage.getItem('utm_source'))
    queryParams.set('utm_medium', sessionStorage.getItem('utm_medium'))
    queryParams.set('utm_campaign', sessionStorage.getItem('utm_campaign'))
    queryParams.set('utm_term', sessionStorage.getItem('utm_term'))
    queryParams.set('utm_content', sessionStorage.getItem('utm_content'))
    return queryParams.toString()
}
const replaceLinkParameters = (link, queryString) => {
    const url = new URL(link.href)
    const parameters = new URLSearchParams(queryString)
    for (const [key, value] of parameters) {
        url.searchParams.set(key, value)
    }
    link.href = url.toString()
}
jQuery(storeInSessionUTMs)

// Non blocking helpers
const yieldToMain = () => new Promise(resolve => setTimeout(resolve, 0))
const runNonBlockingFunctions = (functions) => async () => {
    for (const callback of functions) {
        await yieldToMain()
        callback(jQuery)
    }
}
const onReadyFunctions = []
const onReady = (callback) => onReadyFunctions.push(callback)
const onLoadFunctions = [];
const onLoad = (callback) => onLoadFunctions.push(callback)
addEventListener('DOMContentLoaded', runNonBlockingFunctions(onReadyFunctions))
addEventListener('load', runNonBlockingFunctions(onLoadFunctions));

// Read cookie value
const getCookieValue = (cookieName) => {
    return document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName + '='))
        ?.split("=")[1];
}

const sendLinkedInCapiEvent = (conversionId, email) => {
    const queryParams = new URLSearchParams({
        action: 'send_linkedin_capi_event',
        conversionId: conversionId,
        conversionHappenedAt: Date.now(),
        userEmail: email,
    })
    if (window.location.search.includes('li_fat_id')) {
        queryParams.set('userLiFatId', new URLSearchParams(window.location.search).get('li_fat_id'))
    }
    fetch('/wp-admin/admin-ajax.php?' + queryParams.toString())
}
// Debounce function to limit how often a function can fire
const debounce = (mainFunction, delay) => {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            mainFunction(...args);
        }, delay);
    };
};
